import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.components.WorkflowWizardPopup.PreviewStep', {
    title: "Good job! Let's review your settings",
    subtitle: 'Activating the workflow will not affect anything in your accounting system.',
    saveAndActivate: 'Save and activate',
    saveWithoutActivating: 'Save without activating',
});
